// Add your custom JS here.
(function ($) {
    AOS.init();

    $(".submenu-toggle").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Eerst vinden we het parent li element
        const parentLi = $(this).closest("li.menu-item-has-children");

        // Dan voegen we de klasse toe aan het submenu binnen dit li element
        parentLi.find("> .sub-menu").toggleClass("submenu-active");
        // Of je kunt de klasse aan het li element zelf toevoegen
        // parentLi.toggleClass("submenu-active");

        return false;
    });

    // Close the submenu when clicking on the sub-menu submenu-active ::before
    $(document).on("click", function (e) {
        // Check if the clicked element is not a submenu toggle or inside a submenu
        if (
            !$(e.target).closest(".submenu-toggle").length &&
            !$(e.target).closest(".sub-menu").length
        ) {
            // Remove the submenu-active class from all sub-menus
            $(".sub-menu").removeClass("submenu-active");
        }
    });

    // HEADER SCROLL FUNCTIONS
    $(document).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $("#wrapper-navbar").addClass("off-top");
        }
        if ($(this).scrollTop() < 50) {
            $("#wrapper-navbar").removeClass("off-top");
        }
    });

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
        }
        lastScrollTop = st;
    });

    // Steps swiper
    var uspSwiper = new Swiper(".usp-swiper", {
        slidesPerView: 1,
        direction: "vertical",
        autoplay: true,
        loop: true,
    });

    // Logo swiper
    var uspSwiper = new Swiper(".logo-swiper", {
        slidesPerView: "auto",
        autoplay: true,
        loop: true,
        center: true,
    });

    // Review swiper
    var reviewSwiper = new Swiper(".review-swiper", {
        slidesPerView: 1,
        effect: "cards",
        autoplay: true,
    });

    //Members-swiper
    var membersSwiper = new Swiper(".members-swiper", {
        slidesPerView: "auto",
        loop: false,
        center: true,
        spaceBetween: 24,

        //swiper pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        breakpoints: {
            0: {
                slidesPerView: 1.2,
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 5,
            },
        },
    });

    // FAQ TOGGLE
    $(".faq-item").on("click", function () {
        if (!$(this).hasClass("active")) {
            $(".faq-item.active .answer").slideUp(150);
            $(".faq-item.active").removeClass("active");
            $(this).addClass("active");
            $(this).children(".answer").slideDown(150);
        } else {
            $(this).removeClass("active");
            $(this).children(".answer").slideUp(150);
        }
    });

    ////////// HEADER TOGGLE
    $(".menu-toggle").on("click", function () {
        $("#wrapper-navbar").toggleClass("active");

        if ($("#wrapper-navbar").hasClass("active")) {
            $("html").css("overflow", "hidden");
        } else {
            $("html").css("overflow", "");
        }
    });

    ////////// SUB MENU TOGGLE
    // if ($(window).width() < 992) {
    //     $("#wrapper-navbar .menu-item-has-children").on("click", function () {
    //         if ($(this).hasClass("active")) {
    //             $(this).removeClass("active");
    //             $(this).children(".sub-menu").slideUp(150);
    //         } else {
    //             $(this).addClass("active");
    //             $(this).children(".sub-menu").slideDown(150);
    //         }
    //     });
    // }

    //// CASES FILTERING
    $(".all").click(function () {
        // Uncheck all checkboxes
        $('#filter input[type="checkbox"]').prop("checked", false);
        $("#filter").trigger("change");
    });

    $('#filter input[type="checkbox"]')
        .not("#all")
        .click(function () {
            // Uncheck the "#all" checkbox
            $("#all").prop("checked", false);
        });

    //Check the #all checkbox if all other checkboxes are checked
    $('#filter input[type="checkbox"]')
        .not("#all")
        .change(function () {
            if (
                $('#filter input[type="checkbox"]').not("#all").length ==
                $('#filter input[type="checkbox"]:checked').not("#all").length
            ) {
                $("#all").prop("checked", true);
            }
        });

    // vimeo
    if ($(".video iframe").length) {
        // Select all Vimeo players
        var vimeoPlayers = $(".video iframe");

        // Loop through each Vimeo player
        vimeoPlayers.each(function (index) {
            // Assign unique ID to each player
            var playerID = "player-" + (index + 1);
            $(this).attr("id", playerID);

            // Assign unique ID to each player toggle
            var playerToggleID = "player-toggle-" + (index + 1);
            $(this).siblings(".play").attr("id", playerToggleID);

            // Clone the iframe
            var clonedIframe = $(this).clone();

            // Remove "?background=1" from the iframe URL
            var iframeSrc = clonedIframe.attr("src");
            if (iframeSrc.indexOf("?background=1") !== -1) {
                iframeSrc = iframeSrc.replace("?background=1", "");
                clonedIframe.attr("src", iframeSrc);
            }

            // Create a div for the player popup
            var playerPopupID = "player-popup-" + (index + 1);
            var playerPopup = $(
                '<div class="player-popup" id="' +
                    playerPopupID +
                    '"><div class="close">Sluiten</div></div>'
            );

            // Append the cloned iframe to the player popup div
            playerPopup.append(clonedIframe);

            // Append the player popup div to .video-popups
            $(".video-popups").append(playerPopup);
        });

        // Loop through each Vimeo player
        $(".video-popups iframe").each(function (index) {
            var iframe = this;
            var player = new Vimeo.Player(iframe);

            // Event listener for player toggle click
            $(".video .play").on("click", function () {
                var elementID = $(this).attr("id");
                var idNumber = parseInt(elementID.replace(/^\D+/g, ""));

                $("#player-popup-" + idNumber + "").addClass("active");
            });

            // Event listener for clicking outside of player popup
            $(".player-popup").on("click", function () {
                $(".player-popup").removeClass("active");
            });
        });
    }

    $(document).on("click", ".mediabirds-popup, .form-popup", function (event) {
        if (event.target === this) {
            $(".mediabirds-popup-close").trigger("click");
        }
    });

    if ($(window).width() > 992) {
        $("#wrapper-navbar .menu > li > .sub-menu").each(function () {
            // Selecteer alle kinderen die geen .menu-item-has-children hebben
            var noChildItems = $(this)
                .children("li")
                .not(".menu-item-has-children");

            // Controleer of er meer dan 5 items zijn
            if (noChildItems.length > 0) {
                // Maak groepen van maximaal 5 items
                var group = [];
                noChildItems.each(function (index) {
                    group.push(this); // Voeg het huidige item toe aan de groep

                    // Als de groep 5 items heeft of het laatste item bereikt is
                    if (
                        group.length === 5 ||
                        index === noChildItems.length - 1
                    ) {
                        $(group).wrapAll("<span class='nochildwrap'></span>"); // Groep inpakken
                        group = []; // Start een nieuwe groep
                    }
                });
            }
        });
    }
})(jQuery);



// teamlid popover
// teamlid popover
document.addEventListener('DOMContentLoaded', function () {
  const dataEl = document.getElementById('team-popover-data');
  let dataset = [];

  try {
    dataset = dataEl ? JSON.parse(dataEl.textContent || '[]') : [];
  } catch (e) {
    dataset = [];
  }

  const container = document.querySelector('.members-wrapper');
  const pop = document.getElementById('memberPopover');
  if (!container || !pop) return;

  const panel = pop.querySelector('.member-panel');
  const closeBtns = pop.querySelectorAll('.js-close-member');

  const imgEl = document.getElementById('mpImage');
  const nameEl = document.getElementById('memberPanelTitle');
  const functieEl = pop.querySelector('.member-panel__functie');

  const rowEmail = pop.querySelector('.row--email');
  const rowTel = pop.querySelector('.row--tel');
  const rowWA = pop.querySelector('.row--wa');
  const rowLI = pop.querySelector('.row--li');

  const emailLink = document.getElementById('mpEmail');
  const emailText = document.getElementById('mpEmailText');
  const telLink = document.getElementById('mpTel');
  const telText = document.getElementById('mpTelText');
  const waLink = document.getElementById('mpWA');
  const liLink = document.getElementById('mpLI');

  // NIEUW: content-elementen
  const contentEl = document.getElementById('mpContent');
  const contentWrap = pop.querySelector('.member-panel__content');

  let lastFocus = null;

  function fill(data) {
    // Foto • Naam • Functie
    imgEl.src = data.image || '';
    imgEl.alt = data.image_alt || data.name || '';
    nameEl.textContent = data.name || '';
    functieEl.textContent = data.functie || '';

    // Contact (alleen tonen als gevuld)
    if (data.email_href && data.email_text) {
      emailLink.href = data.email_href;
      emailText.textContent = data.email_text;
      rowEmail.hidden = false;
    } else {
      rowEmail.hidden = true;
      emailLink.removeAttribute('href');
      emailText.textContent = '';
    }

    if (data.tel_href && data.tel_text) {
      telLink.href = data.tel_href;
      telText.textContent = data.tel_text;
      rowTel.hidden = false;
    } else {
      rowTel.hidden = true;
      telLink.removeAttribute('href');
      telText.textContent = '';
    }

    if (data.wa_href) {
      waLink.href = data.wa_href;
      rowWA.hidden = false;
    } else {
      rowWA.hidden = true;
      waLink.removeAttribute('href');
    }

    if (data.li_href) {
      liLink.href = data.li_href;
      rowLI.hidden = false;
    } else {
      rowLI.hidden = true;
      liLink.removeAttribute('href');
    }

    // NIEUW: Content (WYSIWYG/HTML)
    if (contentEl) {
      if (data.content) {
        contentEl.innerHTML = data.content; // server-side gesanitized via wp_kses_post aanbevolen
        if (contentWrap) contentWrap.hidden = false;
      } else {
        contentEl.innerHTML = '';
        if (contentWrap) contentWrap.hidden = true;
      }
    }
  }

  function openWithIndex(idx) {
    if (!dataset[idx]) return;
    lastFocus = document.activeElement;
    fill(dataset[idx]);
    pop.classList.add('is-open');
    document.documentElement.classList.add('modal-open');
    if (panel) {
      panel.setAttribute('tabindex', '-1'); // zeker stellen dat focusbaar is
      panel.focus({ preventScroll: true });
    }
  }

  function close() {
    pop.classList.remove('is-open');
    document.documentElement.classList.remove('modal-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Klik op slide → open popover
  container.addEventListener('click', function (e) {
    const slide = e.target.closest('.member.swiper-slide');
    if (!slide) return;
    const slides = Array.from(container.querySelectorAll('.member.swiper-slide'));
    const idx = slides.indexOf(slide);
    if (idx > -1) {
      e.preventDefault();
      openWithIndex(idx);
    }
  });

  // Toetsenbord (Enter/Spatie) op focusbare slide
  container.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const slide = e.target.closest('.member.swiper-slide');
    if (!slide) return;
    const slides = Array.from(container.querySelectorAll('.member.swiper-slide'));
    const idx = slides.indexOf(slide);
    if (idx > -1) {
      e.preventDefault();
      openWithIndex(idx);
    }
  });

  // Sluiten
  closeBtns.forEach(btn =>
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    })
  );

  const backdrop = pop.querySelector('.member-popover__backdrop');
  if (backdrop) backdrop.addEventListener('click', close);

  // ESC + focus trap
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && pop.classList.contains('is-open')) {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab' && pop.classList.contains('is-open')) {
      const f = pop.querySelectorAll('a,button,[tabindex]:not([tabindex="-1"])');
      const list = Array.from(f).filter(el => !el.disabled && el.offsetParent !== null);
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }
  });
});
